<template>
  <div>
    <a-modal
      centered
      :title="title"
      v-model="reportModal"
      :width="width"
      :maskClosable="false"
      @ok="handleOk"
      :footer="null"
    >
      <iframe
        :src="url"
        ref="iframe"
        style="height: calc(100vh - 70px);width:100%;border:1px solid rgb(229,229,229);"
      ></iframe>
    </a-modal>
  </div>
</template>

<script>
// import { cache } from "@/utils/common";   ;width: calc(100vw - 75px)
export default {
  name: "StsConfigBaseGoodsManage",
  props: {
    title: {
      type: String,
      default: ""
    },
    url: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: ""
    },
    height: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      reportModal: false,
      tableURL: "",
      user: {}
    };
  },
  watch: {},
  created() {
    // this.user = cache.get("user");
    // this.tableURL =
    //   this.user.ReportUrl +
    //   "/show?reportid=" +
    //   this.$route.query.reportid +
    //   "&url=" +
    //   this.$route.query.url +
    //   "&Token=" +
    //   this.user.Token;
  },
  mounted() {
    this.reportModal = true;
  },
  methods: {
    onCancel() {
      this.$emit("destroy");
    },
    handleOk() {
      this.reportModal = false;
    }
  }
};
</script>

<style lang="less" scoped>
.page-body {
  position: absolute;
  /* top: 43.56px; */
  bottom: 0;
  width: 100%;
  /* padding: 6px; */
}
</style>
